import React, { FC } from 'react';

interface TableProps {
  children: React.ReactNode;
}

const Table: FC<TableProps> = ({ children }) => {
  const tableClassName =
    'table align-middle table-hover w-100 container tableStyle';
  return (
    <table cellSpacing={0} className={tableClassName}>
      {children}
    </table>
  );
};

export default Table;
